import { Reducer } from 'redux';
import {
  IFabricationContract,
  IFabricationContractState,
  Types
} from './types';

const INITIAL_STATE: IFabricationContractState = {
  contracts: undefined,
  loading: false,
  error: false,
  orderVersionReviewContract: undefined
};

type CustomAction = {
  type: Types;
  payload: {
    contracts: IFabricationContract[];
    contractNumber: string;
    contractDetails: IFabricationContract;
    contract: IFabricationContract;
  };
};

const reducer: Reducer<IFabricationContractState, CustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    // CONTRATOS
    case Types.LOAD_CONTRACTS:
      return { ...state, loading: true, error: false, contracts: undefined };
    case Types.LOAD_CONTRACTS_V2:
      return { ...state, loading: true, error: false, contracts: undefined };
    case Types.LOAD_CONTRACTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        contracts: action.payload.contracts,
        updatedAt: Date.now()
      };
    case Types.LOAD_CONTRACTS_FAILURE:
      return { ...state, loading: false, error: true, contracts: [] };

    case Types.LOAD_CONTRACT_DETAILS:
      return {
        ...state,
        loading: true,
        contracts: updateContractDetails(
          action.payload.contractNumber,
          state.contracts || [],
          true,
          false
        )
      };
    case Types.LOAD_CONTRACT_DETAILS_V2:
      return {
        ...state,
        loading: true,
        contracts: updateContractDetails(
          action.payload.contractNumber,
          state.contracts || [],
          true,
          false
        )
      };

    case Types.LOAD_CONTRACT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        contracts: updateContractDetails(
          action.payload.contractNumber,
          state.contracts || [],
          false,
          false,
          action.payload.contractDetails
        )
      };
    case Types.LOAD_CONTRACT_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        contracts: updateContractDetails(
          action.payload.contractNumber,
          state.contracts || [],
          false,
          true
        )
      };

    case Types.LOAD_CONTRACT_BY_CONTRACT_NUMBER:
      return { ...state, loading: true, error: false, contractError: false };
    case Types.LOAD_CONTRACT_BY_CONTRACT_NUMBER_V2:
      return { ...state, loading: true, error: false, contractError: false };
    case Types.LOAD_CONTRACT_BY_CONTRACT_NUMBER_SUCCESS:
      return {
        ...state,
        selectedContract: action.payload.contractDetails,
        loading: false,
        contracts: !state.contracts
          ? [action.payload.contractDetails]
          : [...state.contracts]
      };
    case Types.LOAD_CONTRACT_BY_CONTRACT_NUMBER_FAILURE:
      return { ...state, loading: false, error: true, contractError: true };

    case Types.CLEAR_FABRICATION_CONTRACTS:
      return INITIAL_STATE;

    case Types.LOAD_ORDER_VERSION_REVIEW_SUCCESS:
      return {
        ...state,
        orderVersionReviewContract: action.payload.contract
      };

    case Types.CLEAR_ORDER_VERSION_REVIEW:
      return {
        ...state,
        orderVersionReviewContract: undefined
      };

    case Types.LOAD_ORDER_VERSION_REVIEW_FAILURE:
      return {
        ...state,
        orderVersionReviewContract: undefined
      };

    case Types.LOAD_REQUEST_NEW_ORDER_SUCCESS:
      return {
        ...state,
        requestNewOrderContract: action.payload.contract
      };

    case Types.LOAD_REQUEST_NEW_ORDER_FAILURE:
      return {
        ...state,
        requestNewOrderContract: undefined
      };

    default:
      return state;
  }
};

const updateContractDetails = (
  contractNumber: string,
  contracts: IFabricationContract[],
  loading: boolean,
  error: boolean,
  contractDetails?: IFabricationContract
): IFabricationContract[] => {
  const selectedContractIdx = contracts.findIndex(
    (contract) => contract.contractNumber === contractNumber
  );
  if (selectedContractIdx !== -1) {
    const updatedContract = {
      ...contracts[selectedContractIdx],
      ...contractDetails
    };

    contracts[selectedContractIdx] = {
      ...updatedContract,
      loadingDetails: loading,
      errorDetails: error
    };
  }

  return contracts;
};

export default reducer;
